module.exports = __webpack_public_path__ + "img/Documents.fc22fc9a.svg";